import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from './config';
import '../css/AdminManagement.css';

function SystemAdmin() {
  const navigate = useNavigate();
  const actor = useMemo(() => JSON.parse(localStorage.getItem('user') || 'null'), []);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const authFetch = useCallback(async (path, options = {}) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {})
      }
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.message || 'ทำรายการไม่สำเร็จ');
    return data;
  }, []);

  const loadUsers = useCallback(async query => {
    try {
      setLoading(true);
      setError('');
      const data = await authFetch(`/api/admin/users?q=${encodeURIComponent(query || '')}`);
      setUsers(data.users || []);
    } catch (loadError) {
      setError(loadError.message);
    } finally {
      setLoading(false);
    }
  }, [authFetch]);

  useEffect(() => {
    if (!actor || String(actor.role).toLowerCase() !== 'admin') {
      navigate('/', { replace: true });
      return undefined;
    }
    const timer = window.setTimeout(() => loadUsers(search), 300);
    return () => window.clearTimeout(timer);
  }, [actor, loadUsers, navigate, search]);

  const changePassword = async player => {
    const password = window.prompt(`ตั้ง Password ใหม่ให้ ${player.name}\nอย่างน้อย 4 ตัวอักษร`);
    if (password === null) return;
    if (password.length < 4) return alert('Password ต้องมีอย่างน้อย 4 ตัวอักษร');
    try {
      setBusyId(player.user_id);
      const data = await authFetch(`/api/admin/users/${player.user_id}/password`, {
        method: 'PATCH', body: JSON.stringify({ password })
      });
      alert(data.message);
    } catch (changeError) {
      alert(changeError.message);
    } finally {
      setBusyId(null);
    }
  };

  const deleteUser = async player => {
    if (!window.confirm(`ลบผู้เล่น “${player.name}” และข้อมูลที่เกี่ยวข้องทั้งหมดใช่หรือไม่?\nการลบไม่สามารถย้อนกลับได้`)) return;
    try {
      setBusyId(player.user_id);
      const data = await authFetch(`/api/admin/users/${player.user_id}`, { method: 'DELETE' });
      setUsers(current => current.filter(item => Number(item.user_id) !== Number(player.user_id)));
      alert(data.message);
    } catch (deleteError) {
      alert(deleteError.message);
    } finally {
      setBusyId(null);
    }
  };

  if (!actor || String(actor.role).toLowerCase() !== 'admin') return null;

  return (
    <main className="admin-management">
      <header className="admin-management-header">
        <div>
          <button type="button" className="admin-back" onClick={() => navigate('/dashboard')}>← Dashboard</button>
          <h1>🛡 System Admin</h1>
          <p>ค้นหา ลบ และเปลี่ยน Password ผู้เล่นทั้งหมด</p>
        </div>
      </header>
      <section className="admin-search-panel">
        <label htmlFor="admin-user-search">ค้นหาผู้เล่น</label>
        <input id="admin-user-search" value={search} onChange={event => setSearch(event.target.value)} placeholder="พิมพ์ชื่อหรือ Player ID..." autoFocus />
        <span>พบ {users.length} คน</span>
      </section>
      {error && <div className="admin-message error">{error}</div>}
      {loading ? <div className="admin-empty">กำลังค้นหา...</div> : users.length === 0 ? <div className="admin-empty">ไม่พบผู้เล่น</div> : (
        <section className="admin-user-list">
          {users.map(player => {
            const isAdmin = String(player.role || '').toLowerCase() === 'admin';
            const isBusy = Number(busyId) === Number(player.user_id);
            return (
              <article className="admin-user-card" key={player.user_id}>
                <div className="admin-user-avatar">{String(player.name || '?').slice(0, 1)}</div>
                <div className="admin-user-info">
                  <strong>{player.name}</strong>
                  <span>ID {player.user_id} • {player.level_rank || '-'} • {Number(player.point || 0)} คะแนน • {player.group_count} Group</span>
                  {isAdmin && <small className="admin-role">ADMIN</small>}
                </div>
                <div className="admin-user-actions">
                  <button type="button" disabled={isBusy} onClick={() => changePassword(player)}>🔑 เปลี่ยน Password</button>
                  <button type="button" className="danger" disabled={isBusy || isAdmin || Number(actor.user_id) === Number(player.user_id)} onClick={() => deleteUser(player)}>🗑 ลบผู้เล่น</button>
                </div>
              </article>
            );
          })}
        </section>
      )}
    </main>
  );
}

export default SystemAdmin;
